import React from 'react'
import Lottie from "lottie-react";
import groovyWalkAnimation from "./../assets/stars.json";
import { useMediaQuery, useTheme } from '@mui/material';


export default function StarIcon({isLoading}: {isLoading: boolean}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Lottie  style={{width: isSmallScreen?60:60,transform: isSmallScreen ? 'scale(1.5)':'scale(2)'}} animationData={groovyWalkAnimation} loop={isLoading || false} />
  )
}
